import moment from "moment";
import { useState, useEffect, useCallback } from "react";
import { alertSuccess, alertError, alertActive } from "../../../components/alert/swal";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
// import { RoutePath } from "../../../routes/Routes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BANNER_TYPE, CONTENT_NEWS_ENUM, CONTENT_TYPE, STATUS_ENUM } from "../website-structure/content/enum/content.enum";
import { ContentApi, contentDataType } from "../../../api/content/content.api";
import { TagsApi, tagsList } from "../../../api/tags/tags.api";
import { CategoryApi, categoryList } from "../../../api/category/category.api";
import { produce } from "immer";
import { RootState } from "../../../store/store";
import { checkPermission } from "../../../utils/app.utils";
import { useTranslation } from "react-i18next";

const initialErrorMessage = {
    content_start_date: "",
    content_end_time: "",
    content_name: "",
    content_start_time: "",
    content_end_date: "",
}

export const ManageStateDetail = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_ADMISSION', permission);

    const [formState, setFormState] = useState<contentDataType>({
        is_public: false,
        content_start_date: "",
        content_end_time: moment().add(10, 'year').format("HH:mm"),
        content_name: "",
        content_start_time: "",
        content_end_date: moment().add(10, 'year').format("YYYY-MM-DD"),
        banner_type: BANNER_TYPE.TYPE_ONE,
        content_desc: "",
        content_detail: "",
        content_files: [],
        content_categorys: [],
        content_status_name: CONTENT_NEWS_ENUM.NEW,
        content_tags: [],
        content_type: CONTENT_TYPE.CONTENT,
        status: STATUS_ENUM.DRAFT
    })
    const [search_category, set_search_category] = useState<string>("");
    const [content_category, set_content_category] = useState<any[]>([]);
    const [category_data, set_category_data] = useState<any[]>([]);
    const [search_content_tags, set_search_content_tags] = useState<string>("");
    const [content_tags, set_content_tags] = useState<any[]>([]);
    const [content_tag_data, set_content_tag_data] = useState<any[]>([]);
    const [id_content, set_id_content] = useState<number | null>(null);
    const [errorMessage, setErrorMessage] = useState<{
        content_start_date: string;
        content_end_time: string;
        content_name: string;
        content_start_time: string;
        content_end_date: string;
    }>(initialErrorMessage)
    const [image_upload, set_image_upload] = useState<File[]>([]);
    const [file_api_url, set_file_api_url] = useState<string>("");
    const [showModal, setShowModal] = useState<string>("")
    const [id_media_file, set_id_media_file] = useState<number | null>(null);

    const [vdo_data, set_vdo_data] = useState<any[]>([]);

    const [content_no, set_content_no] = useState<string>("");

    const [image_api, set_image_api] = useState<any[]>([]);



    const handleChangeFormState = (field: keyof contentDataType, value: any) => {
        clearErrorMessage();
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("");
    }
    const clearErrorMessage = () => {
        setErrorMessage(initialErrorMessage)
    }

    const handleChangeImageApi = (media_files: any[]) => {
        const media_files_data = media_files?.map((list) => {
            return {
                ...list,
                is_image: true
            }
        })
        set_image_api((prev) => ([...prev, ...media_files_data]))
    }
    const handleDeleteImageApi = (index: number) => {
        set_image_api((prev) => prev.filter((_, i) => i !== index))
    }


    const handleGetDetail = async () => {
        dispatch(setLoading());
        const id_content = await ContentApi.list({ page: 1, limit: 10, content_type: CONTENT_TYPE.ADMISSION }).then((res) => res.data?.data?.items[0]?.id_content || null);
        set_id_content(id_content)
        if (id_content) {
            await ContentApi.findOne(id_content).then((res) => {
                if (res.status < 300) {
                    const data = res.data?.data || null;
                    const content_category = res.data?.data?.content_categorys?.map((list: any) => {
                        return {
                            ...list,
                            ...list?.category
                        }
                    })
                    const content_vdo_files: any[] = data?.content_vdo_files || [];
                    set_content_category(content_category);
                    const content_tags = res.data?.data?.content_tags?.map((list: any) => {
                        return {
                            ...list,
                            ...list?.tag
                        }
                    }) || [];
                    if (content_vdo_files?.length > 0) {
                        set_vdo_data(content_vdo_files?.map((list) => {
                            return {
                                ...list,
                                created_date: list?.modified_date,
                                gallery_link: list?.link || "",
                                id_media_file: list?.id_media_file,
                                media_file_name: list?.file_name,
                                media_file_path: list?.file_path,
                                media_file_size: list?.media_file_size || ""
                            }
                        }))
                    } else {
                        set_vdo_data([]);
                    }
                    const media_file_data: any[] = data?.content_files || [];
                    set_content_tags(content_tags)
                    set_content_no(data?.content_no || "")
                    if (media_file_data?.length > 0) {
                        const image_data_media_file = media_file_data?.map((list) => {
                            return {
                                ...list,
                                ...list?.media_file,
                                is_image: true
                            }
                        })
                        set_image_api(image_data_media_file);
                    }
                    setFormState((prev) => ({
                        ...prev,
                        ...data,
                        content_start_time: data?.content_start_date ? moment(data?.content_start_date).format("HH:mm") : "",
                        content_end_time: data?.content_end_date ? moment(data?.content_end_date).format("HH:mm") : "",
                    }))
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            console.warn("ยังไม่ได้สร้าง Content สักรายการ")
        }
    }

    const handleGetTags = useCallback(async () => {
        let query: tagsList = {
            page: 1,
            limit: 10,
        }
        if (search_content_tags) query.keyword = search_content_tags
        await TagsApi.list(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data?.data?.items || [];
                set_content_tag_data(data_value)
            }
        }).catch((err) => err)
    }, [search_content_tags])
    const handleGetCategory = useCallback(async () => {
        let query: categoryList = {
            page: 1,
            limit: 10,
        }
        if (search_category) query.keyword = search_category
        await CategoryApi.list(query).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data?.data?.items || [];
                set_category_data(data_value)
            }
        }).catch((err) => err)
    }, [search_category])

    const handleDeleteImage = (index_file: number) => {
        set_vdo_data((prev) => {
            return produce(prev, (draft) => {
                draft.splice(index_file, 1);
            });
        });
    };

    const generateForm = (status: string, is_public?: number): contentDataType => {
        const start_date: string | null = formState.content_start_date
            ? moment(
                `${moment(formState.content_start_date).format("YYYY-MM-DD")}${formState.content_start_time ? ` ${formState.content_start_time}` : ''}`
            ).format(formState.content_start_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";

        const end_date: string | null = formState.content_end_date
            ? moment(
                `${moment(formState.content_end_date).format("YYYY-MM-DD")}${formState.content_end_time ? ` ${formState.content_end_time}` : ''}`
            ).format(formState.content_end_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : "";
        return {
            is_public: is_public ? !!is_public : !!formState.is_public,
            // content_end_time: formState.content_end_time,
            content_name: formState.content_name,
            // content_start_time: formState.content_start_time,    
            content_end_date: end_date,
            content_start_date: start_date,
            // status: status,
            banner_type: formState.banner_type,
            content_desc: formState.content_desc,
            content_detail: formState.content_detail,
            content_categorys: content_category?.length > 0 ? content_category?.map((list) => {
                return {
                    id_category: list?.id_category
                }
            }) : [],
            content_status_name: formState.content_status_name,
            content_tags: content_tags?.length > 0 ? content_tags?.map((list) => {
                return {
                    id_tag: list?.id_tag
                }
            }) : [],
            content_vdo_files: vdo_data?.length > 0 ? vdo_data?.map((list) => {
                return {
                    id_content_vdo_file: list?.id_content_vdo_file,
                    link: list?.link || ""
                }
            }) : [],
            content_type: CONTENT_TYPE.ADMISSION,
            content_files: image_api?.length > 0 ? image_api?.map((list) => {
                return {
                    id_media_file: list?.id_media_file,
                }
            }) : []
        }
    }
    const handleUploadVdo = async (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        dispatch(setLoading());
        await ContentApi.createVdoFile(formData).then((res) => {
            if (res.status < 300) {
                console.log(res.data, 'data');
                const data_vdo = res.data?.data || null
                set_vdo_data((prev) => ([...prev, data_vdo]))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleDeletedVdoFile = (id_content_vdo_file: number) => {
        alertActive(t("ลบรายการ"), t("ต้องการลบรายการหรือไม่?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ContentApi.deleteVdo(id_content_vdo_file).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบรายการ"), t("ลบรายการสำเร็จ"));
                    handleGetDetail();
                }
            }).catch((err) => {
                console.log(err);
                alertError(t("ลบรายการ"), t("ลบรายการไม่สำเร็จ"));
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const validate_data = (accept?: boolean): boolean => {
        let is_not_valid: boolean = false;
        if (!formState.content_name && accept) {
            setErrorMessage((prev) => ({ ...prev, content_name: t("ระบุหัวข้อ") }))
            is_not_valid = true
        }
        // if (!formState.content_start_date && accept) {
        //     setErrorMessage((prev) => ({ ...prev, content_start_date: "ระบุวันที่เริ่มต้นเผยแพร่" }))
        //     is_not_valid = true
        // }
        // if (!formState.content_end_date && accept) {
        //     setErrorMessage((prev) => ({ ...prev, content_end_date: "ระบุวันที่สิ้นสุดเผยแพร่" }))
        //     is_not_valid = true
        // }
        // if (!formState.content_start_time && accept) {
        //     setErrorMessage((prev) => ({ ...prev, content_start_time: "ระบุเวลาที่เริ่มต้นเผยแพร่" }))
        //     is_not_valid = true
        // }
        // if (!formState.content_end_time && accept) {
        //     setErrorMessage((prev) => ({
        //         ...prev, content_end_time: "ระบุเวลาที่สิ้นสุดเผยแพร่"
        //     }))
        //     is_not_valid = true
        // }
        // if (!formState.content_name) {
        //     setErrorMessage((prev) => ({ ...prev, content_name: "ระบุชื่อข่าวประชาสัมพันธ์" }))
        //     is_not_valid = true
        // }
        return is_not_valid
    }
    const handleSubmit = async (mode: "DRAFT" | "SUBMIT") => {
        const body = generateForm(mode === 'DRAFT' ? STATUS_ENUM.DRAFT : STATUS_ENUM.ACTIVE, mode === 'SUBMIT' ? 1 : 0);
        const is_not_valid = validate_data(mode === 'SUBMIT' ? true : false);
        if (is_not_valid) return;
        dispatch(setLoading());
        if (id_content) {
            await ContentApi.update(id_content, body).then((res) => {
                if (res.status < 300) {
                    handleGetDetail();
                    alertSuccess(t("อัพเดต Admission"), t("อัพเดต Admission เรียบร้อยแล้ว"))
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("อัพเดต Admission"), t("อัพเดต Admission ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await ContentApi.create(body).then(async (res) => {
                if (res.status < 300) {
                    alertSuccess(t("เพิ่ม Admission"), t("เพิ่ม Admission เรียบร้อยแล้ว"))
                    window.location.reload();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("เพิ่ม Admission"), t("เพิ่ม Admission ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }

    }


    useEffect(() => {
        handleGetTags();
    }, [handleGetTags])
    useEffect(() => {
        handleGetCategory();
    }, [handleGetCategory])
    useEffect(() => {
        handleGetDetail();
    }, [])


    return {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        image_upload,
        id_media_file,
        set_image_upload,
        set_file_api_url,
        set_id_media_file,
        file_api_url,
        setShowModal,
        handleCloseModal,
        showModal,
        setFormState,
        image_api,
        handleChangeImageApi,
        handleDeleteImageApi,
        content_no,
        content_category,
        set_content_category,
        category_data,
        set_search_category,
        content_tag_data,
        content_tags,
        set_content_tags,
        set_search_content_tags,
        vdo_data,
        set_vdo_data,
        handleDeleteImage,
        handleUploadVdo,
        handleDeletedVdoFile,
        checkPermit
    }
}